import { withAuthGate } from '@sunrise-ui/composites';
import InboxConversationView from '@templates/InboxConversationView';
import React from 'react';

function IntroducedScreen() {
  return <InboxConversationView connectionType="introduced" />;
}

export default withAuthGate(IntroducedScreen);
